(function($) {
  var footerStickyButton, furtherProductionsHidden, furtherProductionsHiddenToggle, furtherProductionsSlider, furtherProductionsSliderContainer, furtherProductionsSliderYear, furtherProductionsSlides, header, i, item, key, len, menuOverlay, menuOverlayCloseButton, menuOverlayOpenButton, menuOverlayToggle, networkSlider, pressArchiveListItems, primaryNavigationItems, productionMediaSlider, scrollDownButton;
  // Add Numbers to Primary Navigation
  primaryNavigationItems = $('.menu-header-primary li a');
  for (key = i = 0, len = primaryNavigationItems.length; i < len; key = ++i) {
    item = primaryNavigationItems[key];
    (function() {
      var paddedNumber;
      paddedNumber = ('00' + (key + 1)).slice(-2);
      return $('<b>' + paddedNumber + '</b>').prependTo(item);
    })();
  }
  // Sticky Header
  header = $('body:not(.home) header .container');
  if (header.length > 0) {
    header.headroom({
      offset: $('header').next('section').outerHeight(),
      tolerance: 5
    });
  }
  // Hide Back to Story Button at Bottom
  footerStickyButton = $('footer .sticky-button');
  $(window).on('scroll', function() {
    if ($(window).scrollTop() + $(window).height() >= $(document).height()) {
      return footerStickyButton.addClass('sticky-hidden');
    } else {
      return footerStickyButton.removeClass('sticky-hidden');
    }
  });
  // Toggle Overlay Menu
  menuOverlay = $('.menu-overlay');
  menuOverlayToggle = $('header .tcon');
  menuOverlayOpenButton = $('header .toggle');
  menuOverlayCloseButton = menuOverlay.find('.menu-close');
  menuOverlayToggle.on('click', function(e) {
    $(this).toggleClass('tcon-transform');
    menuOverlay.toggleClass('open');
    return $('header .container').toggleClass('invisible');
  });
  menuOverlayOpenButton.on('click', function(e) {
    e.preventDefault();
    return menuOverlay.addClass('open');
  });
  menuOverlayCloseButton.on('click', function(e) {
    e.preventDefault();
    return menuOverlay.removeClass('open');
  });
  // Scroll Down Button
  scrollDownButton = $('.scroll-down');
  scrollDownButton.on('click', function(e) {
    e.preventDefault();
    return $('html, body').animate({
      scrollTop: $(this).closest('section').next('section').offset().top - 36
    }, 500);
  });
  // Toggle Further Productions
  furtherProductionsHidden = $('.further-productions li.hidden');
  furtherProductionsHiddenToggle = $('.further-productions .production-action button');
  furtherProductionsHiddenToggle.on('click', function(e) {
    e.preventDefault();
    if (furtherProductionsHiddenToggle.data('toggle-status') === 'closed') {
      furtherProductionsHidden.addClass('visible');
      furtherProductionsHiddenToggle.data('toggle-status', 'opened');
      return furtherProductionsHiddenToggle.text(furtherProductionsHiddenToggle.data('toggle-opened'));
    } else {
      furtherProductionsHidden.removeClass('visible');
      furtherProductionsHiddenToggle.data('toggle-status', 'closed');
      return furtherProductionsHiddenToggle.text(furtherProductionsHiddenToggle.data('toggle-closed'));
    }
  });
  // Network Slider
  networkSlider = $('.network ul');
  if (networkSlider.length > 0) {
    networkSlider.slick({
      responsive: [
        {
          breakpoint: 5760,
          settings: 'unslick'
        },
        {
          breakpoint: 961,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: true,
            touchThreshold: 10
          }
        }
      ]
    });
  }
  // Production Media Slider
  productionMediaSlider = $('.production-media ul');
  if (productionMediaSlider.length > 0) {
    productionMediaSlider.slick({
      adaptiveHeight: true,
      prevArrow: $('.production-media .prev'),
      nextArrow: $('.production-media .next'),
      infinite: true
    });
  }
  // Further Productions Slider
  furtherProductionsSliderContainer = $('.further-productions-slider');
  furtherProductionsSliderYear = furtherProductionsSliderContainer.find('h4');
  furtherProductionsSlider = furtherProductionsSliderContainer.find('ul');
  furtherProductionsSlides = furtherProductionsSlider.find('li');
  if (furtherProductionsSlider.length > 0) {
    furtherProductionsSlider.slick({
      adaptiveHeight: true,
      prevArrow: $('.further-productions-slider-prev'),
      nextArrow: $('.further-productions-slider-next'),
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      touchThreshold: 10,
      responsive: [
        {
          breakpoint: 961,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
    furtherProductionsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      var productionYear;
      productionYear = $(furtherProductionsSlides[nextSlide]).data('year');
      return furtherProductionsSliderYear.html(productionYear);
    });
  }
  // Make Press-Archive List-Item Clickable
  pressArchiveListItems = $('.press-archive-list li');
  return pressArchiveListItems.on('click', function(e) {
    var listItemTarget;
    e.preventDefault();
    listItemTarget = $(this).find('.press-archive-more').attr('href');
    return $(location).attr('href', listItemTarget);
  });
})(jQuery);

//# sourceMappingURL=script.js.map
